export default __webpack_public_path__ + "static/media/unicef.9090fe6a.png";